import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=e5cb859e&scoped=true"
import script from "./customerService.vue?vue&type=script&lang=js"
export * from "./customerService.vue?vue&type=script&lang=js"
import style0 from "./customerService.vue?vue&type=style&index=0&id=e5cb859e&prod&lang=less&scoped=true"
import style1 from "./customerService.vue?vue&type=style&index=1&id=e5cb859e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cb859e",
  null
  
)

export default component.exports